import API from "../../../utils/helpers/API.helpers";
import { removeKeysWithNullValues } from "../../../utils/helpers/common.helpers";

const RevisiService = {
  async getDeadlineRevisi(mKSpesialId) {
    return await API.get({
      endpoint: `/pengingat-revisi/?mk_spesial=${mKSpesialId}`,
    });
  },
  async updateDeadlineRevisi(deadlineRevisiDetails) {
    if (deadlineRevisiDetails.id) {
      return await API.put({
        endpoint: `/pengingat-revisi/${deadlineRevisiDetails.id}/`,
        data: deadlineRevisiDetails,
      });
    } else {
      return await API.post({
        endpoint: "/pengingat-revisi/",
        data: deadlineRevisiDetails,
      });
    }
  },
  async getRiwayatRevisiPribadi(mKSpesialId) {
    return await API.get({
      endpoint: `/dosen/get-riwayat-revisi?mk_spesial=${mKSpesialId}`,
    });
  },
  async getRiwayatRevisiDosenLain(mKSpesialId) {
    return await API.get({
      endpoint: `/dosen/get-riwayat-revisi-lain?mk_spesial=${mKSpesialId}`,
    });
  },
  async createRevisiDosen(revisionDetails) {
    const data = removeKeysWithNullValues(revisionDetails);
    return await API.post({ endpoint: "/revisi-dosen/", data: data });
  },
  async updateRevisiDosen(revisionId, revisionDetails) {
    return await API.put({
      endpoint: `/revisi-dosen/${revisionId}/`,
      data: revisionDetails,
    });
  },
};

export default RevisiService;
